import "@corecrm/ui/styles.css";
import { BUILD_ID, ToastProvider, reloadOnStaleChunks } from "@corecrm/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { onUnauthenticated } from "./api/client";
import { keys } from "./api/queries";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: true, retry: 1 },
  },
});

// A session that expired mid-visit: forget the client, and the guard sends them to sign in.
onUnauthenticated(() => queryClient.setQueryData(keys.me, null));

// A screen whose code a deploy removed reloads into the new build.
reloadOnStaleChunks();

// Installable PWA: the service worker caches the app shell (never API data or files).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () =>
    navigator.serviceWorker.register(`/sw.js?v=${BUILD_ID}`).catch(() => {}),
  );
}

// The shared stylesheet's portal layout (no staff sidebar or search) hangs off this class.
document.body.classList.add("portal");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
